import ImgLessonDefault from "@/assets/default_img_lesson.png";
import { cn } from "@/utils";
import MarkDoneImg from "@/assets/done.png";

interface Props {
  id: number;
  title?: string;
  coverImage?: string | null;
  score?: number;
  passed?: boolean;
  question_count?: number;
  isDone?: boolean;
  onClick?: () => void;
}

export const QuizCard = ({
  title,
  coverImage,
  score = 0,
  passed,
  question_count,
  isDone,
}: Props) => {
  return (
    <div className="space-y-2 text-dark text-sm cursor-pointer group">
      <div className="w-full aspect-video rounded-md bg-light_grey overflow-hidden shadow-[0_0.5px_5px_rgba(0,0,0,0.25)_inset]">
        <img
          src={coverImage || ImgLessonDefault}
          alt={title}
          onError={(e) => {
            (e.target as HTMLImageElement).src = ImgLessonDefault;
          }}
          className="w-full h-full object-fill group-hover:scale-[1.125] duration-300"
        />
      </div>
      <div className="flex flex-row gap-1 w-full">
        <p className="flex-1 font-semibold leading-5.5 line-clamp-2 h-11 group-hover:text-cyan duration-200">
          {title}
        </p>
        {!isNaN(score) && !isNaN(question_count!) && (
          <div
            className={cn(
              "w-10 h-10 flex justify-center items-center text-white text-xs font-bold rounded-full",
              passed ? "bg-success_lighter" : "bg-error_main"
            )}
          >
            {score}/{question_count}
          </div>
        )}
        {isDone && (isNaN(score) || isNaN(question_count!)) && (
          <img src={MarkDoneImg} className="h-6 w-6" />
        )}
      </div>
    </div>
  );
};
